import { PercentPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { VarDirective } from '@shared/directives/var.directive';
import { MoneyPipe } from '@shared/pipes/money.pipe';

import { ContractedInvestigatorAmountValues } from '../../../../types/investigator-forecast.types';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [VarDirective, MoneyPipe, PercentPipe],
  selector: 'aux-investigator-forecast-overview-amount',
  template: `
    <ng-container>
      <div
        *ngVar="values || {} as contractedValues"
        class="border border-aux-gray-dark bg-white p-4"
      >
        <div class="grid grid-cols-2 gap-y-3">
          <span>Contracted Investigator Amount:</span>
          <span class="text-right">{{ contractedValues.totalInvestigatorCosts | money }}</span>

          <div class="col-span-2 h-1 border-b border-aux-gray-dark"></div>

          <span>Visit Costs to Date:</span>
          <span class="text-right">{{ contractedValues.visitCostsToDate | money }}</span>

          <span>Invoiceables to Date:</span>
          <span class="text-right">{{ contractedValues.invoiceablesToDate | money }}</span>

          <span>Invoiceables %:</span>
          <span class="text-right">{{ contractedValues.invoiceablesPerc | percent }}</span>

          <div class="col-span-2 h-1 border-b border-aux-gray-dark"></div>

          <span class="font-bold">Remaining</span>
          <span class="text-right font-bold">{{ contractedValues.remainingAmount | money }}</span>
        </div>
      </div>
    </ng-container>
  `,
})
export class InvestigatorForecastOverviewAmountComponent {
  @Input() values!: ContractedInvestigatorAmountValues;
}
